<mat-card class="mainclass">
  <div class="header">
    <div class="d-flex align-items-center">
      <div class="icon">
        <span class="material-symbols-outlined" style="cursor: default !important;"> local_library  </span>
    </div>
    <div class="heading">Trainings</div>
    </div>
    <span class="material-symbols-outlined audit_icon" (click)="backToTrainingGrid1('Trainings','2')">
      settings
    </span>
  
  </div>
 
  <div class="table-container ">
    <table class="">
      <tr class="" > 
         <td class="countvalue border-right" >{{trainingdata?.TotalActiveTrainings??0}}<br>
          <div class="textsize underline" (click)="backToTrainingGrid1('Trainings','2')">Training</div>
        </td>

        <td class="countvalue border-right">{{trainingdata?.UpcomingTrainings??0}}<br>
          <div class="textsize underline" (click)="backToTrainingGrid1('Upcoming Trainings','1')">Upcoming Training</div>
        </td>

        <td class="countvalue">{{trainingdata?.TechTalks??0}}<br>
          <div class="textsize underline" (click)="backToTrainingGrid1('Tech Talks','3')">Tech Talks</div>
        </td>

      </tr>
    </table>

  </div>

   


</mat-card>